export default {
  "notifications": {
    "broken_favorite": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ukjent status, leter etter den…"])},
    "favorited_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["likte din status"])},
    "followed_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["fulgte deg"])},
    "load_older": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Last eldre varsler"])},
    "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Varslinger"])},
    "read": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Les!"])},
    "repeated_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gjentok din status"])},
    "no_more_notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingen gjenstående varsler"])},
    "follow_request": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ønsker å følge deg"])}
  }
}